// extracted by mini-css-extract-plugin
export default {"menu":"page-heading-size_menu__QlRLE","item":"page-heading-size_item__Lyeve"};